import { render, staticRenderFns } from "./customerList.modal.vue?vue&type=template&id=36b434f5"
import script from "./customerList.modal.vue?vue&type=script&lang=js"
export * from "./customerList.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports